import React from "react"
import { Tooltip } from "../Tooltip"
import { fetchCampaign } from "../../services/dataStore"
import { filterEmptyValues } from "../../helpers/filterEmptyValues"
import { REGISTRATION_ENDPOINT } from "../../constants/urls"
import {
  PROMO_CODE_COOKIE,
  COOKIE_DOMAIN,
} from "../../constants/cookies"

const Cookies = require("js-cookie")

interface SignupFormFieldsProps extends SignupFormFieldsState {
  buttonColor?: string,
  buttonTextColor?: string,
  buttonHoverColor?: string,
  buttonActiveColor?: string,
  showTerms?: boolean,
  toolTipPosition?: "top" | "bottom" | "left" | "right",
}

interface SignupFormFieldsState {
  callToAction?: string,
  code?: string,
}

interface FetchDataParams {
  retry?: boolean,
  code?: string,
}

class SignupFormFieldsInner extends React.Component<
SignupFormFieldsProps,
SignupFormFieldsState> {
  public static defaultProps = {
    callToAction: "Get Started",
    code: "",
    buttonColor: "black",
    buttonTextColor: "white",
    buttonHoverColor: "black-secondary",
    buttonActiveColor: "gray-dark",
    showTerms: true,
    toolTipPosition: "bottom",
  }

  constructor(props: SignupFormFieldsProps) {
    super(props)
    this.state = {
      callToAction: props.callToAction,
      code: "",
    }
  }

  renderTerms() {
    const {
      showTerms,
      callToAction,
      toolTipPosition,
      buttonColor,
    } = this.props

    if (showTerms) {
      const tooltipContent = `By clicking ${callToAction}, you agree to receive emails from Gobble, our Terms of Use,
and consent to our Privacy Policy. Gobble is a subscription service.`

      return (
        <Tooltip content={tooltipContent} position={toolTipPosition} trigger="auto">
          <span className={`text-${buttonColor} underline cursor-pointer text-xs`}>
            Terms
          </span>
        </Tooltip>
      )
    }
  }

  componentDidMount() {
    const code = this.getPromoCode()
    this.setDefaultState()

    if (code) {
      this.fetchData({ code })
    }
  }

  private setDefaultState(): void {
    this.setState({ ...this.props })
  }

  private getPromoCode(): string {
    const { code } = this.props
    const cookieCode: string = Cookies.get(PROMO_CODE_COOKIE, { domain: COOKIE_DOMAIN })
    return cookieCode || code
  }

  private async fetchData({ code }: FetchDataParams) {
    try {
      const query = `
        callToAction
        code
      `
      let campaign = await fetchCampaign(query, code)
      campaign = filterEmptyValues(campaign)
      this.setState({ ...campaign })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const {
      callToAction,
      code,
    } = this.state

    const {
      buttonColor,
      buttonTextColor,
      buttonHoverColor,
      buttonActiveColor,
    } = this.props

    return (
      <div className="w-full">
        <form className="form flex flex-col" action={REGISTRATION_ENDPOINT} method="POST">
          <div className="grid lg:grid-cols-3 gap-6 mb-6">
            <div>
              <label htmlFor="registration_email" className="sr-only">Email</label>
              <input
                type="text"
                placeholder="Your Email Address"
                className="text-base text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="registration_email"
                name="registration[email]"
                required
              />
            </div>
            <div>
              <label className="sr-only" htmlFor="password">Password</label>
              <input
                type="password"
                placeholder="Create a Password"
                className="text-base text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="password"
                name="registration[password]"
                minLength={4}
                required
              />
            </div>
            <div>
              <label className="sr-only" htmlFor="zip_code">Zipcode</label>
              <input
                type="string"
                placeholder="Your ZIP code"
                className="text-base text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="zip_code"
                name="registration[zip_code]"
                maxLength={5}
                required
              />
            </div>
          </div>
          <div className="form-field">
            <input
              type="hidden"
              name="promo_code"
              value={code}
            />
          </div>
          <button
            type="submit"
            data-analytics="signup-cta"
            className={`inline-block text-center font-bold rounded-full leading-snug
              no-underline transition-all duration-200 ease-in-out
              active:[box-shadow:0px_4px_4px_0px_rgba(0,0,0,0.25)_inset]
              hover:no-underline text-base border border-transparent
              mx-auto px-6 py-3.5 bg-${buttonColor} text-${buttonTextColor}
              hover:bg-${buttonHoverColor} active:bg-${buttonActiveColor}`}
          >
            {callToAction}
          </button>
          {this.renderTerms()}
        </form>
      </div>
    )
  }
}

export function SignupFormFields(props: SignupFormFieldsProps) {
  return <SignupFormFieldsInner {...props} />
}
